export const utilitiesMixin = {
    methods: {
        compareValues(value1, value2) {
            return JSON.stringify(value1) === JSON.stringify(value2);
        },
        deepCopy(obj) {
            /**
             * This function makes a deep copy of the object provided as argument.
             * There are currently three ways to generate a clone of an object.
             * 1) Object.assign() => generates a shallow clone
             * 2) Spread operator => generates a shallow clone
             * 3) JSON.parse(JSON.stringify(object)) => generates a deep clone
             * Only option 3 creates a deep clone. Therefore this is used here.
             * The result is that we cannot add functions to an object, we want
             * to deep copy.
             */
            return JSON.parse(JSON.stringify(obj));
        },
    }
}